<template>
  <div class="auth__signup-content">
    <div class="auth__signup-content__header flex-box-ends">
      <h2 class="signup__title">Create a <span>new account</span></h2>
      <div>
        <img src="/static/moneywave.png" width="138" height="auto" alt="Moneywave Logo">
      </div>
    </div>
    <div class="auth__signup-content__body">
      <div class="panel">
        <div class="panel__header">
          <div class="panel__header__left">
            <div class="tag tag--light-green">2 of 2</div>
            <div>Business <span>information</span></div>
          </div>
          <div class="panel__header__right">
            <router-link :to="{name:'signup-personal'}" class="btn btn--default btn--sm">Back</router-link>
          </div>
        </div>

        <div class="panel__content panel__content--grey outer-container">
          <div class="auth__signup-form">
            <transition name="slide-fade">
              <div v-if="displayInputsError" class="form__input--error--overall">
                <p v-for="error in userErrors">{{error}}</p>
              </div>
            </transition>

            <form action="" @submit.prevent="handleSignUp()">
              <div class="auth__signup-form__item form__item">
                <div class="form-title">Your business is<span class="input-required">*</span></div>
                <div class="radio__item" @click="isUnregisteredBusiness()">
                  <input type="radio" name="business-option" id="unregistered" value="unregistered-business" class="radio__item__input" v-model="userBusinessType" checked>
                  <label for="unregistered" class="radio__item__label">an Unregistered business</label>
                </div>
                <div class="radio__item" @click="isregisteredBusiness()">
                  <input type="radio" name="business-option" id="registered" value="registered-business" class="radio__item__input" v-model="userBusinessType" >
                  <label for="registered" class="radio__item__label">a Registered Business</label>
                </div>
                <div class="radio__item" @click="isNGOBusiness()">
                  <input type="radio" name="business-option" id="ngo" value="ngo-business" class="radio__item__input" v-model="userBusinessType" >
                  <label for="ngo" class="radio__item__label">a Non-profit / NGO</label>
                </div>
              </div>

              <!--forms to show depending on options above-->
              <div class="auth__signup-form__item form__item">
                <label  v-if="unregisteredBusiness">Business <span>name</span><span class="input-required">*</span></label>
                <label  v-if="registeredBusiness">Registered <span>business name</span><span class="input-required">*</span></label>
                <label  v-if="ngoBusiness">NGO <span>name</span><span class="input-required">*</span></label>
                <input type="text" class="form__input" @keydown="nameKeydown($event)" v-model="userbusinessName" placeholder="Your business">
              </div>

              <!--business description-->
              <div class="auth__signup-form__item form__item form__item__long-text">
                <label>Give us a bit description of your business<span class="input-required">*</span></label>
                <textarea rows="3" class="form__input" v-model="userBusinessDescription" placeholder="E.g. We design and sell bespoke software"></textarea>
              </div>

              <!--select currencies needed-->
              <div class="auth__signup-form__item form__item form__item--block">
                <div class="form-title badge__info__trigger">Your <span>wallet currencies</span>
                  <span class="info-icon"></span>
                    <div class="badge__info">
                      <span class="badge__info__text">Information about wallet</span>
                    </div>
                </div>
                <p class="form-title__subtitle">Select the currencies you need to transact in</p>
                <div class="wallet__currencies">
                  <input type="checkbox" id="ngn" value="NGN" class="checkbox__input" v-model="selectedCurrencies">
                  <label for="ngn" class="checkbox__label">NGN</label>
                  <input type="checkbox" id="ksh" value="KES" class="checkbox__input" v-model="selectedCurrencies">
                  <label for="ksh" class="checkbox__label">KES</label>
                  <input type="checkbox" id="ghs" value="GHS" class="checkbox__input" v-model="selectedCurrencies">
                  <label for="ghs" class="checkbox__label">GHS</label>
                  <input type="checkbox" id="tzs" value="TZS" class="checkbox__input" v-model="selectedCurrencies">
                  <label for="tzs" class="checkbox__label">TZS</label>
                  <input type="checkbox" id="ugx" value="UGX" class="checkbox__input" v-model="selectedCurrencies">
                  <label for="ugx" class="checkbox__label">UGX</label>
                  <label class="" style="margin-left: 24px"><a @click="toggleCurrency()" class="default-style">Show More</a></label>
                </div>
                <div class="wallet__currencies" v-if="showMoreCurrency">
                  <input type="checkbox" id="usd" value="USD" class="checkbox__input" v-model="selectedCurrencies">
                  <label for="usd" class="checkbox__label">USD</label>
                  <input type="checkbox" id="RWF" value="RWF" class="checkbox__input" v-model="selectedCurrencies">
                  <label for="RWF" class="checkbox__label">RWF</label>
                  <input type="checkbox" id="ZMW" value="ZMW" class="checkbox__input" v-model="selectedCurrencies">
                  <label for="ZMW" class="checkbox__label">ZMW</label>
                  <input type="checkbox" id="SLL" value="SLL" class="checkbox__input" v-model="selectedCurrencies">
                  <label for="SLL" class="checkbox__label">SLL</label>
                  <input type="checkbox" id="XAF" value="XAF" class="checkbox__input" v-model="selectedCurrencies">
                  <label for="XAF" class="checkbox__label">XAF</label>
                  <input type="checkbox" id="XOF" value="XOF" class="checkbox__input" v-model="selectedCurrencies">
                  <label for="XOF" class="checkbox__label">XOF</label>
                </div>
              </div>

              <!--agreement-->
              <div class="auth__signup-form__item checkbox">
                <input type="checkbox" id="agreementCheck" class="checkbox__input" v-model="agreementChecked" @click="agreementWarn = false">
                <label for="agreementCheck" id="agreementlabel" class="checkbox__label">
                  <span>I agree to the </span>
                </label>
                <span class="link default-style" data-toggle="modal" data-target="#termsCondition" > Terms of Service & Privacy Policy</span>
                
                <!--if error exists-->
                <transition name="slide-fade">
                  <div class="form__input--error--text" v-if="agreementWarn">
                    <p>Check terms and agreement to continue</p>
                  </div>
                  <div class="form__input--error--text" v-else-if="signUpError">
                    <p>{{ signUpError.toUpperCase() }}</p>
                  </div>
                </transition>
              </div>
              <!--submit form-->
              <div class="auth__signup-form__item submit__signup-form">
                <button class="btn btn--primary btn--block" type="submit" :disabled="signupDisabled">CREATE YOUR NEW ACCOUNT</button>
              </div>

            </form>

            <div class="text-center"><p>Already have an account? <router-link :to="{name:'login'}" class="default-style">Login here</router-link></p></div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="termsCondition"
      tabindex="-1"
      role="dialog"
      aria-labelledby="termsCondition"
    >
      <div class="modal__dialog modal__dialog--lg" role="document">
        <!-- Modal content -->
        <div class="modal__content">
          <div class="modal__header">
            <div class="modal__title">
              <h3> Terms of Service & Privacy Policy </h3>
            </div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                <path
                  fill="#C0C6D8"
                  fill-rule="nonzero"
                  d="M8.254 6.5l4.383-4.382A1.24 1.24 0 0 0 10.882.363L6.5 4.746 2.118.363A1.24 1.24 0 1 0 .363 2.118L4.746 6.5.363 10.882a1.24 1.24 0 0 0 1.755 1.755L6.5 8.254l4.382 4.383a1.24 1.24 0 1 0 1.755-1.755L8.254 6.5z"
                ></path>
              </svg>
            </button>
          </div>

          <div
            class="modal__body modal__body--pad" style="padding: 3%;"
          >
          <div>
            <h2> ONLINE PRIVACY STATEMENT </h2>
            <br>

            Flutterwave Inc. ("Company") is committed to protecting your privacy. We have prepared this Privacy Policy to describe to you our practices regarding the Personal Data (as defined below) we collect from users of our website ("Site") and Services (as defined in the Agreement of our Terms and Conditions).
            <br><br>

            User Consent. By submitting Personal Data through our Site or Services, you agree to the terms of this Privacy Policy and you expressly consent to the collection, use and disclosure of your Personal Data in accordance with this Privacy Policy.
            <br><br>

            A Note About Children. We do not intentionally gather Personal Data from visitors who are under the age of 13.
            <br><br>

            Types of Data We Collect. "Personal Data" means data that allows someone to identify or contact you, including, for example, your name, address, telephone number, e-mail address, as well as any other non-public information about you that is associated with or linked to any of the foregoing data. "Anonymous Data" means data that is not associated with or linked to your Personal Data; Anonymous Data does not, by itself, permit the identification of individual persons. We collect Personal Data and Anonymous Data, as described below.
            <br><br>

            1. Information Collected via Technology.
            <br>
            2. Information You Provide to Us.
            <br><br>

            We may collect Personal Data from you, such as your first and last name, gender, e-mail and mailing addresses, date of birth, phone number and password when you create an account to log in to our network ("Account") and register for a Flutterwave Card ("Card"). When you register on our Site to load a card, we will collect all information necessary to complete the transaction, including your name and credit card information.
            We retain information on your behalf, such as previous transactions you have completed and messages that you store using your Account. If you provide us feedback or contact us via e-mail, we will collect your name and e-mail address, as well as any other content included in the e-mail, in order to send you a reply.
            <br><br>

            When you participate in one of our surveys, we may collect additional profile information. When you post messages on the blogs on our Site, the information contained in your posting will be stored on our servers and other users will be able to see it. We may also collect Personal Data, such as at other points in our Site that state that Personal Data is being collected.
            <br><br>

            <h2> TERMS AND CONDITIONS </h2>
            <br>

            <b> PLEASE READ THESE TERMS AND CONDITIONS OF USE CAREFULLY BEFORE USING THIS WEB SITE. BY USING THIS SITE, YOU OR THE ENTITY YOU ARE AUTHORIZED TO REPRESENT ("YOU" OR "YOUR") SIGNIFY YOUR AGREEMENT TO THESE TERMS AND CONDITIONS OF USE. YOU MUST AGREE TO THESE TERMS AND CONDITIONS IN ORDER TO USE THE FLUTTERWAVE WEB SITE. PLEASE READ THIS DOCUMENT CAREFULLY. IF YOU DO NOT AGREE TO ALL OF THE TERMS AND CONDITIONS OF THIS AGREEMENT, DO NOT USE THIS SITE! </b>
            <br><br>

            Flutterwave, Inc. ("FLUTTERWAVE") may revise and update these Terms and Conditions at anytime. Please periodically review the Terms and Conditions posted at the FLUTTERWAVE web site because your continued usage of the web site after any changes to these Terms and Conditions will mean you accept those changes.
            <br><br>

            <b> SECTION 1. USE OF CONTENT - COPYRIGHT </b>
            <br><br>

            Upon acceptance of these Terms and Conditions, FLUTTERWAVE authorizes you to view or download a single copy of the material on this web site solely for your personal, informational and noncommercial use, provided that you retain all copyright and other proprietary notices contained in the original material on any copies of the material. Such material specified above does not include the design or layout of the FLUTTERWAVE web site. Elements of the FLUTTERWAVE web site are protected by trade dress, trademark, unfair competition, and other laws and may not be copied or imitated in whole or in part. No logo, graphic, sound or image from the FLUTTERWAVE web site may be copied or retransmitted unless expressly permitted by FLUTTERWAVE. Special rules or license terms may apply to the use of certain software and other items provided to you via the FLUTTERWAVE web site (collectively, "Portal"). Any such special rules or license terms accompany or are listed in association with or through a hyperlink associated with the Portal.
            <br><br>

            The contents of the FLUTTERWAVE web site ("Content"), such as text, graphics, data, images, Portal and other material are protected by copyright and other laws in both the United States and other countries, and title to the Content shall not pass to you or any other party. Except to the extent required by law or as expressly provided herein, none of the Content may be reverse-engineered, disassembled, decompiled, reproduced, translated into any language or computer language, re-transmitted in any form or by any means (electronic, mechanical, photoreproduction, recordation or otherwise), resold or redistributed without the prior written consent of FLUTTERWAVE. you may not sell or modify the Content or reproduce, display, publicly perform, distribute or otherwise use the Content in any way for any public or commercial purpose. Without limitation of the foregoing, unless independently licensed by FLUTTERWAVE, use of the Content on any other web site or in a networked computer environment for any purpose is prohibited.
            <br><br>

            Content is subject to change without notice at the editorial discretion of FLUTTERWAVE. If you violate any of these Terms and Conditions, your permission to use the Content automatically terminates and you must immediately destroy any copies you have made of any portion of the Content.
            <br><br>

            <b> SECTION 2. LIMITATION OF FLUTTERWAVE'S LIABILITY - DISCLAIMER OF RESPONSIBILITY FOR DAMAGES </b>
            <br><br>

            FLUTTERWAVE makes no representations about the results to be obtained from using the FLUTTERWAVE web site, FLUTTERWAVE Systems, the Information or the Content. The use of same is at your own risk.
            <br><br>

            WHEN USING THE FLUTTERWAVE WEB SITE AND FLUTTERWAVE SYSTEMS, INFORMATION AND CONTENT WILL BE TRANSMITTED OVER A MEDIUM WHICH IS BEYOND THE CONTROL AND JURISDICTION OF FLUTTERWAVE AND ITS SUPPLIERS. ACCORDINGLY, FLUTTERWAVE ASSUMES NO LIABILITY FOR OR RELATING TO THE DELAY, FAILURE, INTERRUPTION OR CORRUPTION OF ANY CONTENT OR INFORMATION.
            <br><br>

            THE FLUTTERWAVE WEB SITE, FLUTTERWAVE SYSTEMS, THE INFORMATION AND THE CONTENT ARE PROVIDED ON AN "AS IS" BASIS WITHOUT ANY WARRANTIES OF ANY KIND. FLUTTERWAVE, ITS LICENSORS, AND ITS SUPPLIERS, TO THE FULLEST EXTENT PERMITTED BY LAW, DISCLAIM ALL WARRANTIES, EITHER EXPRESS OR IMPLIED, STATUTORY OR OTHERWISE, INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT OF THIRD PARTIES' RIGHTS, AND FITNESS FOR PARTICULAR PURPOSE. FLUTTERWAVE, ITS LICENSORS, AND ITS SUPPLIERS MAKE NO REPRESENTATIONS OR WARRANTIES ABOUT THE ACCURACY, RELIABILITY, COMPLETENESS, CURRENTNESS OR TIMELINESS OF THE CONTENT, INFORMATION, SOFTWARE, TEXT, GRAPHICS, LINKS, OR COMMUNICATIONS PROVIDED ON OR THROUGH THE USE OF THE FLUTTERWAVE WEB SITE OR FLUTTERWAVE SYSTEMS.
            <br><br>

            IN NO EVENT SHALL FLUTTERWAVE, ITS LICENSORS, SUPPLIERS OR ANY THIRD PARTIES MENTIONED AT THE FLUTTERWAVE WEB SITE BE LIABLE FOR ANY DAMAGES OR PENALTIES WHATSOEVER (INCLUDING, WITHOUT LIMITATION, INCIDENTAL INDIRECT, EXEMPLARY, PUNITIVE AND CONSEQUENTIAL DAMAGES, LOST PROFITS, OR DAMAGES RESULTING FROM LOST DATA OR BUSINESS INTERRUPTION) RESULTING FROM THE USE OR INABILITY TO USE THE FLUTTERWAVE WEB SITE OR THE CONTENT WHETHER BASED ON WARRANTY, CONTRACT, TORT, DELICT, OR ANY OTHER LEGAL THEORY, AND WHETHER OR NOT FLUTTERWAVE IS ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. FLUTTERWAVE SHALL BE LIABLE TO YOU ONLY TO THE EXTENT OF ACTUAL DAMAGES INCURRED BY YOU. THE REMEDIES STATED FOR YOU IN THESE TERMS AND CONDITIONS ARE EXCLUSIVE AND ARE LIMITED TO THOSE EXPRESSLY PROVIDED FOR IN THESE TERMS AND CONDITIONS.
            <br><br>

            <b> SECTION 3. LINKS </b>
            <br><br>

            The FLUTTERWAVE web site contains links to third party web sites. These links are provided solely as a convenience to you and not as an endorsement by FLUTTERWAVE of the content on such third-party web sites. FLUTTERWAVE is not responsible for the content of linked third-party web sites and does not make any representations regarding the content or accuracy of materials on such third-party web sites.
            <br>
            If you decide to access linked third-party web sites, you do so at your own risk. your use of third-party web sites is subject to any applicable terms and conditions of use for such sites. Linking to any page of the FLUTTERWAVE web site other than http://www.flutterwave.com through a plain text link is strictly prohibited in the absence of a separate linking Agreement with FLUTTERWAVE. Any web site or other device that links to http://www.flutterwave.com is prohibited from (a) replicating Content, (b) using a browser or border environment around the Content, (c) implying in any fashion that FLUTTERWAVE is endorsing it or its products, (d) misrepresenting any state of facts, including its relationship with FLUTTERWAVE, (e) presenting false information about FLUTTERWAVE products or services, and (f) using any FLUTTERWAVE logo or mark without permission from FLUTTERWAVE.
            <br><br>

            <b> SECTION 4. U.S./EU "SAFE HARBOR" See European Union Privacy Statement </b>
            <br><br>

            <b> SECTION 5. INDEMNITY </b>
            <br><br>

            You agree to defend, indemnify and hold FLUTTERWAVE, its officers, directors, employees, agents, licensors and suppliers, harmless from and against any claims, actions or demands, liabilities and settlements including without limitation, reasonable legal and accounting fees, resulting from, or alleged to result from, your use of the Content (including Portal) in a manner that violates or is alleged to violate these Terms and Conditions.


          </div>
          
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getSignupToken} from '../../utils/auth/authService'
  import {registerUser} from '../../utils/auth/authService'
  var errInterval;

export default {
    created() {
      errInterval = setInterval(this.checkForError, 1000);
      setTimeout(() => { clearInterval(errInterval) }, 600000);
    },

    data() {
      return {
        registeredBusiness: false,
        unregisteredBusiness: true,
        ngoBusiness:false,
        agreementChecked:false,
        agreementWarn: false,
        signUpError: window.localStorage.getItem('signUpError'),
        displayInputsError: false,
        signupDisabled: false,
        showMoreCurrency: false,
      }
    },

    computed: {
      // import needed states
      selectedCurrencies:{
        get(){
          return this.$store.state.authUser.currenciesSelected
        },
        set(value){     
          this.$store.commit('updateSelectedCurrency', value);
        }

      },
      userbusinessName: {
        get () {
          return this.$store.state.authUser.businessName
        },
        set (value) {
          this.$store.commit('updateUserBusinessName', value)
        }
      },

      userBusinessType: {
        get () {
          return this.$store.state.authUser.businessType
        },
        set (value) {
          this.$store.commit('updateUserBusinessType', value)
        }
      },


      userBusinessDescription: {
        get () {
          return this.$store.state.authUser.businessDescription
        },
        set (value) {
          this.$store.commit('updateUserBusinessDescription', value)
        }
      },
      //display errors
      apiErrors(){
        return this.$store.state.authUser.apiErrors

//        if(this.$store.state.authUser.apiErrors.length > 1){
//          this.displayInputsError = true;
//        }
      }

    },
    methods:{
      nameKeydown(e) {
        if(/[^a-z0-9 /-]/gi.test(e.key)){
          e.preventDefault();
        }
      },
      checkForError () {
        console.log(window.localStorage.getItem('signUpError'));
        if (window.localStorage.getItem('signUpError')) this.signUpError = window.localStorage.getItem('signUpError');
        else this.signUpError = '';
      },
      toggleCurrency(){
        this.showMoreCurrency = !this.showMoreCurrency;
      },
      isregisteredBusiness(){
        this.registeredBusiness = true;
        this.unregisteredBusiness = false;
        this.ngoBusiness = false;
      },
      isUnregisteredBusiness(){
        this.registeredBusiness = false;
        this.unregisteredBusiness = true;
        this.ngoBusiness = false;
      },
      isNGOBusiness(){
        this.registeredBusiness = false;
        this.unregisteredBusiness = false;
        this.ngoBusiness = true;
      },

      //submit signup form

      handleSignUp(){
        if(this.userBusinessType !== '' && this.userbusinessName !== '' && this.userBusinessDescription !== '' && this.agreementChecked){
            this.$Progress.start()
            //call method to create user
            this.$store.dispatch('createUser')

        }

        else{
            this.displayInputsError = true;
            this.$Progress.fail()
            let error = 'Please fill all required fields correctly';
            this.userErrors = [];
            this.userErrors.push(error)

            if(!this.agreementChecked){
              this.agreementWarn = true;
            }

        }


      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/onboarding/SignupBusiness.vue